'use strict';

global = typeof global !== 'undefined' ? global : window;
global.config = typeof window !== 'undefined' ? window.appConfig : context.appContext.config;

const load = () => {
    return global.config.isMobile ? import('./mobile/alert') : import('./desktop/alerts');
};

export function alert(text, title, button, callback) {
    load().then(module => {
        module.alert(text, title, button, callback);
    });
}

export function confirm(msg, func, title, okBtn, cancelBtn) {
    if (okBtn && !cancelBtn) {
        // Short method format: msg, func, okBtn, cancelBtn
        cancelBtn = okBtn;
        okBtn = title;
    }

    load().then(module => {
        module.confirm(msg, func, title, okBtn, cancelBtn);
    });
}

export function prompt(msg, defaultValue, func, title, isQuantity = true) {
    load().then(module => {
        module.prompt(msg, defaultValue, func, title, isQuantity);
    });
}
